export default function modals() {

    const modals = document.querySelectorAll('.modal');
    const modalClose = document.querySelectorAll('.js-modal-close');
    const modalOpen = document.querySelectorAll('.js-modal-open');
    const abonimentModalBtns = document.querySelectorAll('.js-aboniment-modal-btn');
    var distance = 0;

    const notification = document.querySelector('.js-notification');
    const notificationClose = document.querySelectorAll('.js-notification-close');
    const notificationBtn = document.querySelector('.js-notification-btn');

    function disable_scroll() {
        document.querySelector("body").classList.add("dis-scroll");
        document.querySelector("body").scrollTo({
          top: distance,
          left: 0,
        });
    }

    function enable_scroll() {
        document.querySelector("body").classList.remove("dis-scroll");
        if ( distance != 0 ) {
            window.scrollTo({
                top: distance,
                left: 0,
            });
        }
    }

    window.showNotif = function() {
        if (notification) {
            notification.classList.add('open');
        }
    }

    window.openModal = function(name) {

        document.querySelector('.modal.open')?.classList.remove('open');

        distance = window.pageYOffset;
        disable_scroll();
        let modal = document.querySelector(`.modal[data-modal="${name}"]`);
        if (modal) {
            modal.classList.add('open');
        }
    }

    function closeModal() {
        let modal = document.querySelector('.modal.open');
        if (modal) {
            modal.classList.remove('open');
            enable_scroll();
        }
    }

    function closeNotification() {
        let notification = document.querySelector('.notification.open');
        if (notification) {
            notification.classList.remove('open');
        }
    }

    if (notificationClose.length > 0) {
        notificationClose.forEach(close => {
            close.addEventListener('click', (e) => {
                e.preventDefault();
                closeNotification();
            });
        });
    }

    if (modals.length > 0) {
        modals.forEach(modal => {
            modal.addEventListener('click', (e) => {
                if (e.target.classList.contains('modal')) {
                    closeModal();
                }
            });
        });
    }

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            closeModal();
            closeNotification();
        }
    });

    if (modalClose.length > 0) {
        modalClose.forEach(close => {
            close.addEventListener('click', (e) => {
                e.preventDefault();
                closeModal();
            });
        });
    }

    if (modalOpen.length > 0) {
        modalOpen.forEach(open => {
            open.addEventListener('click', (e) => {
                e.preventDefault();
                openModal(open.dataset.modal);
            });
        });
    }

    if (abonimentModalBtns.length > 0) {
        abonimentModalBtns.forEach((btn) => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();

                // закрываем модалку и возвращаем скролл
                closeModal();

                // открываем вкладку "абонементы"
                document.querySelector('.js-tab-btn[data-box="2"]')?.click();

                // выбираем нужный абонемент на странице
                const m = String(btn.dataset.aboniment || '').match(/aboniment-(\d+)/);
                if (!m) return;
                const idx = Number(m[1]) - 1;
                if (Number.isNaN(idx) || idx < 0) return;

                const cards = document.querySelectorAll('.aboniments__card');
                const card = cards[idx];
                if (!card) return;

                // не тогглим лишний раз: если уже выбран — ничего не делаем
                if (!card.classList.contains('selected')) {
                    card.querySelector('.js-aboniment-btn')?.click();
                }
            });
        });
    }

    if (notificationBtn) {
        notificationBtn.addEventListener('click', (e) => {
            scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
    }
}